import React, { useEffect } from 'react';

const QuickMenu: React.FC = () => {
  useEffect(() => {
    const quickArea = document.querySelector('.quick-area') as HTMLElement | null;
    const quickOpen = document.querySelector('.quick-open') as HTMLButtonElement | null;
    const quickPanels = document.querySelectorAll<HTMLButtonElement>('.quick-panel');

    if (!quickArea || !quickOpen) return;

    /* ==================================================
        S:: QUICK DEPTH2 CLOSE (COMMON)
    ================================================== */
    const closeAllDepth2 = (): void => {
      quickPanels.forEach((panel) => {
        const li = panel.closest('li');
        const depth2 = li?.querySelector('.quick-depth2-w') as HTMLElement | null;

        if (!li || !depth2) return;

        li.classList.remove('active');
        depth2.style.height = '0';
        panel.setAttribute('title', '메뉴 열기');
      });
    };

    /* ==================================================
        S:: QUICK MENU OPEN / CLOSE
    ================================================== */
    const handleQuickToggle = (): void => {
      const isActive = quickArea.classList.contains('active');

      quickArea.classList.toggle('active', !isActive);
      quickOpen.setAttribute(
        'title',
        isActive ? '퀵메뉴 열기' : '퀵메뉴 닫기'
      );

      if (isActive) {
        closeAllDepth2();
      }
    };

    quickOpen.addEventListener('click', handleQuickToggle);

    /* ==================================================
        S:: QUICK DEPTH2 TOGGLE
    ================================================== */
    quickPanels.forEach((panel) => {
      panel.addEventListener('click', () => {
        const li = panel.closest('li');
        const depth2 = li?.querySelector('.quick-depth2-w') as HTMLElement | null;

        if (!li || !depth2) return;

        const isActive = li.classList.contains('active');

        if (isActive) {
          depth2.style.height = '0';
          li.classList.remove('active');
          panel.setAttribute('title', '메뉴 열기');
        } else {
          depth2.style.height = `${depth2.scrollHeight}px`;
          
          depth2.addEventListener(
            'transitionend',
            () => (depth2.style.height = 'auto'),
            { once: true }
          );

          li.classList.add('active');
          panel.setAttribute('title', '메뉴 닫기');
        }
      });
    });

    // cleanup
    return () => {
      quickOpen.removeEventListener('click', handleQuickToggle);
    };
  }, []);

  return (
    <>
      <div className="quick-bg"></div>
      <aside className="quick-area active">
        <div className="quick-w">
          <button type="button" title="퀵메뉴 닫기" className="quick-open">
            <i className="icon icon-quick"></i>
          </button>
          {/* 20260129 수정 */}
          <ul className="quick">
            <li>
              <a href='https://www.aica-gj.kr/main.php' className="quick-btn" target="_blank" title="새 창 열림">
                AICA 홈페이지
              </a>
            </li>
            <li>
              <button type="button" title="메뉴 열기" className="quick-btn quick-panel">
                AI 통합지원 서비스 플랫폼
              </button>
                <ul className="quick-depth2-w">
                  <li><a href='https://aidc.atops.or.kr/' className="quick-depth2" target="_blank" title="새 창 열림">컴퓨팅자원 신청</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/tsp`} className="quick-depth2" target="_blank" title="새 창 열림">실증장비 이용신청</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/lms`} className="quick-depth2" target="_blank" title="새 창 열림">AI 융합아카데미</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/`} className="quick-depth2" target="_blank" title="새 창 열림">코디네이팅·자문 신청</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/dxp`} className="quick-depth2" target="_blank" title="새 창 열림">데이터안심구역 신청</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/`} className="quick-depth2" target="_blank" title="새 창 열림">회의실 등 예약</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/npu`} className="quick-depth2" target="_blank" title="새 창 열림"> AI 반도체</a></li>
                  {/* <li><a href={`${process.env.REACT_APP_DOMAIN}/biz`} className="quick-depth2" target="_blank" title="새 창 열림">사업관리시스템</a></li> */}
                </ul>
            </li>
          </ul>
        </div>
      </aside>
    </>
  );
};

export default QuickMenu;